'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import JquerywebServices from '@/components/technologies/jqueryweb-services';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Build Light-Weight, Scalable Yet Interactive Application With jQuery app development"
                alt="jQuery app Development"
                title="jQuery app Development"
                width={1090}
                height={604}
                path={'jquery-hero'}
                bgPath={'hero-bg-grunge'}
            >
                jQuery App <div>Development Company</div>
            </TechHero>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="jQuery Development" />

            <ContetVideoSection title="Build Interactive and Scalable jQuery Websites & Apps Using jQuery Library">
                <>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Ensuring smooth interaction between JavaScript and HTML, jQuery is a JavaScript library used to design and
                        build seamless, interactive and scalable web and mobile applications. With minimal coding lines, jQuery
                        can create wonders by developing hassle-free websites in a minimal amount of time. Hence, it saves time,
                        money and resources too.
                    </p>
                </>
            </ContetVideoSection>
            <JquerywebServices title="jQuery Web App Development Solutions"></JquerywebServices>
            <HireProcess
                bg="bg-jqueryapp"
                pageTitle="Hire jQuery Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using jQuery."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For jQuery Development? " />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best jQuery Developers"
                desc="Select from different engagement models to hire jQuery Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
